import { routerActions } from "connected-react-router";
export { RouterAction } from "connected-react-router";
export function createRouterActions() {
    return routerActions;
}

export type RouterActionCreators = typeof routerActions;
